import { getRouteApi } from '@tanstack/react-router';
import type { LOAN_REQUEST_COMMAND } from 'cpool-constants';

import ItemDeleteButton from '../General/ItemDeleteButton.tsx';
import { FormCard } from '~/features/leadDetails/components/Overview/CustomerData/shared/FormCard';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import { canExecuteApplicantCommand } from '~/features/leadDetails/utils/aclPermissions';

type Props = {
    onDelete: () => void;
    children: React.ReactNode;
    isSecondApplicant?: boolean;
    removeCommandName: LOAN_REQUEST_COMMAND;
};

export const IncomeRow: React.FC<Props> = ({ children, isSecondApplicant, onDelete, removeCommandName }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    return (
        <FormCard className="py-0">
            <div className="flex min-w-0 items-start gap-2">
                <div className="min-w-0 flex-1">{children}</div>
                <ItemDeleteButton
                    iconOnly
                    onClick={onDelete}
                    translationPath="DELETE"
                    disabled={
                        !canExecuteApplicantCommand({
                            applicant: isSecondApplicant ? 2 : 1,
                            commandName: removeCommandName,
                            permissions,
                        })
                    }
                />
            </div>
        </FormCard>
    );
};
